import * as React from 'react';
import CssBaseline from '@mui/material/CssBaseline';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Container from '@mui/material/Container';
import { createTheme, ThemeProvider } from '@mui/material/styles';

function Copyright(props) {

    return (
        <Typography variant="body2" color="text.secondary" align="center" {...props}>
            {'Terms of Service -Introduction -  Welcome to CherryPine Creations LLC ("we," "our," "us"). These Terms of Service ("Terms") govern your use of our website, services, and products. By accessing or using our services, you agree to be bound by these Terms. If you do not agree to these Terms, please do not use our services. -   Cancellation Policy  -  Services - Service Cancellation by Customer:            Customers may cancel their service appointments at any time without any fees. Rescheduling is permitted at any time without any additional charges. - Products -           Product Order Cancellation: Orders for in-stock products cannot be canceled once placed as they ship the same day.    Pre-orders cannot be canceled once the purchase is made.  - Refund Policy - Services - Refunds for Services:            Refunds are offered if the product breaks due to a flaw in our design or if there is an unnoticed flaw in the design, material, or manufacturing process. Before issuing a refund, we will first attempt to replace the defective product. Refunds are not offered if the damage to the product is due to user error. Requesting a Refund for Services:            Customers can request a refund by contacting us via email at support@cherrypine.net. - Products - Refunds for Products: Refunds are offered if the product has a manufacturing defect or flaw.   There is no specific time frame for requesting a refund, but the product must meet the above condition.  - Return Policy - Products - Returning Products: There is no time frame for returning products.   There are no specific conditions (e.g., unopened, unused) for returns  Customers are responsible for the cost of return shipping. - Exchanges -  Product Exchanges: We do not offer product exchanges.  -Non-Refundable/Non-Returnable Items-            Non-Refundable/Non-Returnable Services and Products:  Any consulting CAD design time or time spent in meetings and discussing products with our team of engineers is non-refundable and non-returnable. - Additional Information - Contact Information - Customer Support: For any questions regarding cancellations, refunds, or returns, please contact us via email at support@cherrypine.net.'}
            {' '}

            {' '}
        </Typography>
    );
}

// TODO remove, this demo shouldn't need to reset the theme.
let defaultTheme = createTheme({
    palette: {
        mode: 'dark',
    },
});

export default function Terms() {

    return (
        <ThemeProvider theme={defaultTheme}>
            <Container component="main" maxWidth="xs">
                <CssBaseline />
                <Box
                    sx={{
                        marginTop: 1,
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                    }}
                >
                </Box>
                <Copyright sx={{ mt: 8, mb: 4 }} />
            </Container>
        </ThemeProvider>
    );
}